import { useEffect, useState } from 'react';
import { fetchGalleryPage } from '../helpers/contentfulHelper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import styles from '../styles/GalleryPage.module.css';

const GalleryPage = () => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const load = async () => {
      const data = await fetchGalleryPage();
      setPage(data);
    };
    load();
  }, []);

  if (!page) return null;

  const { title, introCopy, galleries } = page.fields;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>

        {introCopy && (
          <div className={styles.intro}>
            {documentToReactComponents(introCopy)}
          </div>
        )}

        <div className={styles.galleryList}>
          {galleries.map((gallery) => (
            <section key={gallery.sys.id} className={styles.gallery}>
              <h2 className={styles.galleryTitle}>
                {gallery.fields.title}
              </h2>

              <div className={styles.grid}>
                {gallery.fields.images.map((img) => (
                  <img
                    key={img.sys.id}
                    src={`https:${img.fields.file.url}`}
                    alt={img.fields.title}
                    className={styles.image}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;